module.exports = __webpack_public_path__ + "static/img/A83.21ea2a58.jpg";